import { supabase } from './supabaseClient';

/**
 * Subscribe to Postgres changes for the given restaurantId and tables.
 * Uses Supabase Realtime if configured; otherwise returns null.
 *
 * @param {object} params
 * @param {string} params.restaurantId
 * @param {string[]} params.tables e.g. ['orders','menu_items','waiter_calls']
 * @param {(payload:any)=>void} params.onChange
 * @param {string} [params.channelName]
 */
export function subscribeRestaurantRealtime({
  restaurantId,
  tables,
  onChange,
  channelName = `rt:restaurant:${restaurantId}`,
}) {
  if (!supabase) return null;
  if (!restaurantId) return null;
  if (!Array.isArray(tables) || tables.length === 0) return null;

  const channel = supabase.channel(channelName);

  for (const table of tables) {
    // Note: this requires Supabase Realtime enabled for the table and RLS policies
    // that allow the authenticated admin to receive changes.
    channel.on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table,
        filter: `restaurant_id=eq.${restaurantId}`,
      },
      (payload) => {
        try {
          onChange?.(payload);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn('Realtime onChange handler failed:', e);
        }
      }
    );
  }

  channel.subscribe((status) => {
    // eslint-disable-next-line no-console
    console.log(`[realtime] ${channelName} status:`, status);
  });

  return channel;
}

export async function unsubscribeChannel(channel) {
  try {
    if (!supabase || !channel) return;
    await supabase.removeChannel(channel);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Failed to remove realtime channel:', e);
  }
}
